/*
pages
*/
//root
import Root from "../pages/Root/index";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import RecoverPassword from "../pages/Authentication/RecoverPassword";
import ChangePassword from "../pages/Authentication/ChangePassword";
import LockScreen from "../pages/Authentication/LockScreen";

// dashboard
import Dashboard from "../pages/Dashboard/index";
import StarterPage from "../pages/StarterPage/index";
import Customers from "../pages/Dashboard/Customers";
import Services from "../pages/Dashboard/Services";
import Templates from "../pages/Dashboard/Templates";
import Invoices from "../pages/Dashboard/Invoice";
import Profile from "../pages/Dashboard/Profile";
import NewClientPage from "../pages/Dashboard/Customers/NewClient";
import NewProductPage from "../pages/Dashboard/Services/NewProduct";
import NewInvoice from "../pages/Dashboard/Invoice/NewInvoice";
import ViewInvoicePDF from "../pages/Dashboard/Invoice/ViewInvoicePDF";
import EmailInvoice from "../pages/Dashboard/Invoice/EmailInvoice";
import EmailVerification from "../pages/Authentication/EmailVerification";
import Subscription from "../pages/Dashboard/Subscription";
import SubscriptionConfirmed from "../pages/Dashboard/Subscription/SubscriptionConfirm";
import LandingPage from "../pages/LandingPage";
import AboutUs from "../pages/AboutUs";
import ContactUs from "../pages/ContactUs";
import LearnMore from "../pages/LearnMore";
import Imprint from "../pages/Imprint";
import Terms from "../pages/Terms";
import Privacy from "../pages/Privacy";

interface RouteProps {
  path: string;
  component: any;
  exact?: boolean;
}

const publicRoutes: Array<RouteProps> = [
  { path: "/landing-page", component: <LandingPage /> },
  { path: "/learn-more", component: <LearnMore /> },
  { path: "/about-us", component: <AboutUs /> },
  { path: "/imprint", component: <Imprint /> },
  { path: "/terms", component: <Terms /> },
  { path: "/privacy", component: <Privacy /> },
  { path: "/contact-us", component: <ContactUs /> },
  { path: "/auth-login", component: <Login /> },
  { path: "/auth-register", component: <Register /> },
  { path: "/auth-recoverpw", component: <RecoverPassword /> },
  { path: "/auth-changepassword", component: <ChangePassword /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  { path: "/logout", component: <Logout /> },
  { path: "/__/auth/action", component: <EmailVerification /> },
];

const privateRoutes: Array<RouteProps> = [
  { path: "/pages-starter", component: <StarterPage /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/", component: <Root /> },
  { path: "/customers", component: <Customers /> },
  { path: "/new-client", component: <NewClientPage /> },
  { path: "/edit-client", component: <NewClientPage /> },
  { path: "/edit-client/:id", component: <NewClientPage /> },
  { path: "/services", component: <Services /> },
  { path: "/new-service", component: <NewProductPage /> },
  { path: "/edit-service/:id", component: <NewProductPage /> },
  { path: "/templates", component: <Templates /> },
  { path: "/invoices", component: <Invoices /> },
  { path: "/new-invoice", component: <NewInvoice /> },
  { path: "/edit-invoice/:id", component: <NewInvoice /> },
  { path: "/edit-invoice", component: <NewInvoice /> },
  { path: "/email-invoice/:id", component: <EmailInvoice /> },
  { path: "/view-invoice-pdf/:id", component: <ViewInvoicePDF /> },
  { path: "/profile", component: <Profile /> },
  { path: "/subscription", component: <Subscription /> },
  { path: "/subscription-confirmed", component: <SubscriptionConfirmed /> },
];

export { publicRoutes, privateRoutes };
